<div class="feature-card" [class.feature-card--list-view]="showShortDescription" (click)="onCardClick()">
  <!-- Card Content -->
  <div class="feature-card__content">
    <!-- Title, Organization, and Metrics Row -->
    <div class="feature-card__header-section">
      <div class="feature-card__header-left">
        <!-- Title and Bookmark Row -->
        <div class="feature-card__title-row">
          <h3 class="feature-card__title">{{ card.title }}</h3>

          <!-- Bookmark Badge -->
          <div class="feature-card__bookmark" *ngIf="isLoggedIn && isBookmarked">
            <svg class="feature-card__bookmark-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z" fill="#059669"
                stroke="#059669" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>

          <!-- Share feature: commented out for now. Uncomment to re-enable.
          <app-card-share-button
            *ngIf="card.id"
            [title]="card.title"
            [path]="'/dataset/' + card.id"
            kind="Dataset"
          ></app-card-share-button>
          -->
        </div>

        <!-- Short description (one line, ellipsis) - directly below title -->
        <p class="feature-card__short-description" *ngIf="card.shortDescription">{{ card.shortDescription }}</p>

        <!-- Resource server names + query types (below description) -->
        <div class="feature-card__title-tags" *ngIf="card.tags?.length || card.serverAccessTypes?.length">
          <span *ngFor="let tag of card.tags" class="feature-card__tag feature-card__tag--compact">{{ getDisplayTag(tag) }}</span>
          <span *ngFor="let qt of card.serverAccessTypes || []" class="feature-card__tag feature-card__tag--access-type feature-card__tag--compact">{{ qt }}</span>
        </div>

      </div>

      <!-- Inline metrics (list view only) - shown when showShortDescription is true -->
      <div class="feature-card__metrics-inline" *ngIf="showShortDescription && showActivityMetrics && card.metrics">
        <!-- Likes -->
        <div
          class="feature-card__metric-item-inline"
          [class.active]="isLiked"
          *ngIf="card.metrics.likes !== undefined"
        >
          <svg class="feature-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
              [attr.fill]="isLiked ? '#059669' : 'none'" stroke="#059669" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="feature-card__metric-value">{{ card.metrics.likes }}</span>
        </div>
        <!-- Downloads -->
        <div class="feature-card__metric-item-inline" *ngIf="card.metrics.downloads !== undefined">
          <svg class="feature-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span class="feature-card__metric-value">{{ card.metrics.downloads | number }}</span>
        </div>
        <!-- Views -->
        <div class="feature-card__metric-item-inline" *ngIf="card.metrics.views !== undefined">
          <svg class="feature-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="feature-card__metric-value">{{ card.metrics.views | number }}</span>
        </div>
      </div>
    </div>

    <!-- Tags row: data readiness — only rendered when percentage exists -->
    <div class="feature-card__tags" *ngIf="card.percentage != null && card.percentage !== undefined">
      <span class="feature-card__tag feature-card__tag--percentage">
        <img src="/shield-check.svg" alt="Data readiness" class="feature-card__tag-icon" />
        {{ card.percentage }}%
      </span>
    </div>

    <!-- Meta: (FileType • CreatedAt • Public) left | Arrow right (list); (FileType • CreatedAt) left | Public right (grid) -->
    <div class="feature-card__meta">
      <div class="feature-card__meta-left-group">
        <div class="feature-card__meta-left">
          <div class="feature-card__meta-item" *ngIf="card.fileType">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>{{ card.fileType }}</span>
          </div>

          <span class="feature-card__meta-divider" *ngIf="card.fileType && card.date">•</span>

          <div class="feature-card__meta-item" *ngIf="card.date">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>{{ card.date }}</span>
          </div>
        </div>

        <div class="feature-card__badge feature-card__badge--inline" [ngClass]="getBadgeClass()"
          [class.feature-card__badge--right]="!showShortDescription" *ngIf="card.badge">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M12 2C15.31 2 18.23 3.69 20.35 6.26C20.43 6.37 20.5 6.49 20.57 6.61C20.64 6.73 20.71 6.85 20.78 6.97C20.85 7.09 20.91 7.21 20.97 7.33C21.03 7.45 21.08 7.57 21.13 7.69C21.18 7.81 21.23 7.93 21.27 8.05C21.31 8.17 21.35 8.29 21.38 8.41C21.41 8.53 21.44 8.65 21.46 8.77C21.48 8.89 21.5 9.01 21.51 9.13C21.52 9.25 21.52 9.37 21.52 9.49C21.52 9.61 21.52 9.73 21.51 9.85C21.5 9.97 21.48 10.09 21.46 10.21C21.44 10.33 21.41 10.45 21.38 10.57C21.35 10.69 21.31 10.81 21.27 10.93C21.23 11.05 21.18 11.17 21.13 11.29C21.08 11.41 21.03 11.53 20.97 11.65C20.91 11.77 20.85 11.89 20.78 12.01C20.71 12.13 20.64 12.25 20.57 12.37C20.5 12.49 20.43 12.61 20.35 12.72C18.23 15.29 15.31 17 12 17C8.69 17 5.77 15.29 3.65 12.72C3.57 12.61 3.5 12.49 3.43 12.37C3.36 12.25 3.29 12.13 3.22 12.01C3.15 11.89 3.09 11.77 3.03 11.65C2.97 11.53 2.92 11.41 2.87 11.29C2.82 11.17 2.77 11.05 2.73 10.93C2.69 10.81 2.65 10.69 2.62 10.57C2.59 10.45 2.56 10.33 2.54 10.21C2.52 10.09 2.5 9.97 2.49 9.85C2.48 9.73 2.48 9.61 2.48 9.49C2.48 9.37 2.48 9.25 2.49 9.13C2.5 9.01 2.52 8.89 2.54 8.77C2.56 8.65 2.59 8.53 2.62 8.41C2.65 8.29 2.69 8.17 2.73 8.05C2.77 7.93 2.82 7.81 2.87 7.69C2.92 7.57 2.97 7.45 3.03 7.33C3.09 7.21 3.15 7.09 3.22 6.97C3.29 6.85 3.36 6.73 3.43 6.61C3.5 6.49 3.57 6.37 3.65 6.26C5.77 3.69 8.69 2 12 2Z"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span>{{ card.badge }}</span>
        </div>
      </div>
      <div class="feature-card__actions" *ngIf="showShortDescription">
        <button class="feature-card__arrow feature-card__arrow--meta"
          aria-label="View details" (click)="onCardClick(); $event.stopPropagation()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Footer: Like View Download | Arrow (grid view only) -->
  <div class="feature-card__footer" *ngIf="!showShortDescription">
    <!-- Activity icons (Like, View, Download) -->
    <div class="feature-card__footer-metrics" *ngIf="showActivityMetrics && card.metrics && !showShortDescription">
      <div class="feature-card__metric-item" [class.active]="isLiked"
        [class.clickable]="isLoggedIn && likeActionEnabled"
        (click)="onLikeMetricClick($event)" *ngIf="card.metrics.likes !== undefined">
        <svg class="feature-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
            [attr.fill]="isLiked ? '#059669' : 'none'" stroke="#059669" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span class="feature-card__metric-value">{{ card.metrics.likes }}</span>
      </div>
      <div class="feature-card__metric-item" *ngIf="card.metrics.views !== undefined">
        <svg class="feature-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span class="feature-card__metric-value">{{ card.metrics.views | number }}</span>
      </div>
      <div class="feature-card__metric-item" *ngIf="card.metrics.downloads !== undefined">
        <svg class="feature-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span class="feature-card__metric-value">{{ card.metrics.downloads | number }}</span>
      </div>
    </div>

    <div class="feature-card__actions">
      <button class="feature-card__arrow" aria-label="View details">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
</div>